import React from "react";

/**
 * Renders all the workers in the group.
 * @param {*} param0
 */

const groupRendererPosted = ({group}) => {
  const className = group.empCat === 'S' || group.empCat === 'Staff' ? "staff" : "";
  return (
      <div style={{fontSize: 12 }}
        className={className}
      >
        {group.title}
      </div>
  );
};

export default groupRendererPosted;
